module.exports = __webpack_public_path__ + "img/lintutorni_original.4be82050.jpg";